"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const computePrice_1 = require("../computePrice");
const RESERVATION_PARTNERS = ['sevenrooms'];
/**
 * Handles unassigning a reservation from an order and removing any associated reservation deposit.
 * @param _event
 * @param prevState
 */
function default_1(_event, prevState = {}) {
    const order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    delete order.reservation;
    order.payments = order.payments.filter(({ paymentType }) => !RESERVATION_PARTNERS.includes(paymentType.name.toLowerCase()));
    return { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
}
exports.default = default_1;
//# sourceMappingURL=unassignReservation.js.map